export default {
  NODE_ENV: process.env.NODE_ENV,
  MICRO_URL: {
    SHOP: `//localhost:8080`,
    OPERATE: `//localhost:8083`,
    ITEM: `//localhost:8082`,
    ONBOARDING: '//localhost:8083',
  },
  LOGIN_URL: 'https://page.didiglobal.com/public-biz/pc-login/3.0.1/index.html',
  // BASE_API: 'https://b.didi-food.com', // pre环境
  BASE_API: 'http://sim461.rlab.sim.intra.xiaojukeji.com/b-api',
}
